import React from "react";
import { connect } from "react-redux";
import {
  guardarAplicacionExterna,
  editarAplicacionExterna,
} from "../../components/aplicacionExterna/AplicacionExternaService";
import {
  URL,
  getAuthorizationHeader,
  idEmpresa,
  getAuthorizationHeaderUpload,
} from "../../constans/constants";
import { exportarArchivo } from "../lotes/LoteService";
import axios from "axios";
import { logout } from "../login/SesionService";
import { validateForm } from "../../constans/validationUtils";
import DropzoneComponent from "../componentes/DropzoneComponent";
import BreadCrumComponent from "../componentes/BreadCrumComponent";
import AsignarColaboradoresGrupos from "./AsignarColaboradoresGrupos";
import {
  mostrarErroresEnFormulario, configurarLimpiezaAutomatica, integrarConChkClick,
  integrarConHandleInput, limpiarErrorCampo
} from '../../constans/form-error-utils';
import PantallaCarga from "../mensajeFlash/PantallaCarga";


class ImportarLote extends React.Component {
  processingTimer = null;

  constructor(props) {
    super(props);
    const tipoImportacion = this.getTipoImportacion(props.match.params.tipo);
    const originalHandleInput = this.handleInput;

    this.handleInput = integrarConHandleInput(this, originalHandleInput);


    let today = new Date(),
      date =
        today.getDate() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getFullYear();


    this.state = {
      descripcion: "",
      numeroPatronal: [],
      gruposUsuarios: [],
      tipoDocumento: [],
      lote: [],
      id: "",
      date: date,
      archivoLote: null,
      uploadDisabled: false,
      numeroPatronalID: "",
      tipoDocumentoID: "",
      formatoTipoDocumentoSeleccionado: "",
      isCarpetaPorDefecto: false,
      carpetaPorDefecto: "",
      fileErrorMsg: "",
      path: "",
      mensaje: "",
      severity: "",
      mostrarMensajeFlash: false,
      submit: false,
      openPantallaCarga: false,
      uploadProgress: null,
      requiredNroMtess: false,
      grupoCheckBox: false,
      errors: {
        descripcion: null,
        numeroPatronalID: null,
        tipoDocumentoID: null,
        idGrupo: null,
        carpetaPorDefecto: null
      },
      showErrors: false,
      nombreArchivo: null,
      pesoArchivoMb: null,
      tipoImportacion,
      mostrarAsignacion: false,
    };

  }

  getTipoImportacion = (pathname) => {
    if (pathname === 'documento') return 'documento';
    if (pathname === 'zip') return 'lote';
    if (pathname === 'documento-grupos') return 'grupos';
    return '';
  }

  reglasValidacionCampos = {
    descripcion: [
      { required: true, message: 'Debe proveer una descripcion para el lote' },
      {
        customValidator: (value, formData) => {
          return value.length < 251
        }, message: 'La cantidad maxima de caracteres es de 250'
      }
    ],
    tipoDocumentoID: [
      {
        customValidator: (value, formData) => {
          return value > 0
        }, message: 'Debe seleccionar un tipo de documento'
      },
    ],
    numeroPatronalID: [
      {
        customValidator: (value, formData) => {
          if (!this.validarExtensionDocumento())
            return true
          else
            return value > 0
        }, message: 'Debe elegir una opcion'
      },
    ],
    carpetaPorDefecto: [
      {
        customValidator: (value, formData) => {
          if (!this.state.isCarpetaPorDefecto)
            return true
          else
            return /^(\/[^\/]+)+$/.test(value)
        }, message: 'Ingrese una direccion valida'
      },
    ],
    idGrupo: [
      {
        customValidator: (value, formData) => {
          if (!this.state.grupoCheckBox)
            return true
          else
            return value > 0
        }, message: 'Debe seleccionar un grupo'
      },
    ],
    archivoLote: [
      { required: true, message: 'Debe cargar los documentos para el lote' },
      {
        allowedExtensions: ['zip'],
        message: 'Debe cargar los documentos comprimidos en formato zip'
      },
      {
        allowedMimeTypes: [
          'application/zip'
        ],
        message: 'Tipo de archivo no permitido'
      }
    ]
  }

  validarCamposFormulario = () => {
    let { isValid, errors } = validateForm(this.state, this.reglasValidacionCampos);
    return { isValid, errors }
  }

  handleChange = (event) => {
    this.setState({ ...this.state, [event.target.name]: event.target.checked });
  };


  handleChecked = (event) => {
    const name = event.target.name;
    const val = event.target.checked;
    this.setState({
      [name]: val,
      idGrupo: ""
    });
  }

  checkFileExtension = () => {
    if (this.state.archivoLote == null)
      return "";
    let fileName = this.state.archivoLote.name
    let extension = fileName.substring(fileName.lastIndexOf('.') + 1);
    if (extension === "zip")
      return "zip";
    return extension;
  }


  formatFileSize = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + sizes[i];
  }

  handleArchivo = (archivo) => {
    if (!this.state.tipoDocumentoID) {
      this.setState(prevState => ({
        errors: {
          ...prevState.errors,
          tipoDocumentoID: "Debe seleccionar un tipo de documento primero"
        }
      }))
      mostrarErroresEnFormulario(this.state.errors)
    } else
      this.setState({ archivoLote: archivo, nombreArchivo: archivo.name, pesoArchivoMb: this.formatFileSize(archivo.size) })
    limpiarErrorCampo("archivoLote")
  }

  manejarResultadoSubidaArchivos = (datos) => {
    clearInterval(this.processingTimer);
    this.processingTimer = null;
    this.setState({ openPantallaCarga: false, uploadProgress: null })
    let resultados = {}
    if (datos.error) {
      resultados = {
        idLote: datos.batchId,
        totalRecibos: 0,
        totalCorrectos: 0,
        errors: []
      };
      resultados.errors.push(datos.mensaje)
      this.props.history.push({
        pathname: '/lotes/importacion/error',
        state: resultados
      });
    } else {
      let datosImportacion = datos.datos
      resultados = {
        idLote: datosImportacion.batchId,
        totalRecibos: datosImportacion.totalRows,
        totalCorrectos: datosImportacion.successRows,
        errors: datosImportacion.errors
      };
      this.props.history.push({
        pathname: datosImportacion.errors.length > 0 ? '/lotes/importacion/error' : "/lotes/importacion/exito",
        state: resultados
      });
    }

  }

 
  subirArchivo = event => {
    event.preventDefault();
    const { isValid, errors } = validateForm(this.state, this.reglasValidacionCampos);
    if (isValid) {
      const data = {
        description: this.state.descripcion,
        file: null,
        filename: this.state.filename,
        empresaId: idEmpresa(),
        numeroPatronalId: this.state.numeroPatronalID,
        documentTypeId: this.state.tipoDocumentoID,
        serverFolder: this.state.carpetaPorDefecto
      }
      if (this.state.uploadDisabled) {
        axios
          .post(URL + "lote/import/form/server", data, getAuthorizationHeader())
          .then((res) => {
            this.manejarResultadoSubidaArchivos(res.data)
          }, error => {
            if (error.response.status === 401) {
              logout();
            }
            return error;
          });
      } else {
        this.setState({ openPantallaCarga: true, uploadProgress: 0 });
        let formData = new FormData();
        formData.append("file", this.state.archivoLote);
        const uploadConfig = {
          ...getAuthorizationHeaderUpload(),
          onUploadProgress: (e) => {
            // El upload ocupa la primera mitad del progreso (0-50%)
            const pct = Math.round((e.loaded / e.total) * 50);
            this.setState({ uploadProgress: pct });
          }
        };
        axios
          .post(URL + "lote/upload", formData, uploadConfig)
          .then((res) => {
            if (res.data.error == false) {
              // El upload terminó, arranco animación simulada 50→90%
              // mientras el servidor procesa el ZIP
              this.setState({ uploadProgress: 50 });
              this.processingTimer = setInterval(() => {
                this.setState(prev => {
                  if (prev.uploadProgress >= 90) return null;
                  return { uploadProgress: prev.uploadProgress + 1 };
                });
              }, 200);
              data.file = res.data.datos;
              axios
                .post(URL + "lote/import/form/client", data, getAuthorizationHeader())
                .then((res) => {
                  clearInterval(this.processingTimer);
                  this.processingTimer = null;
                  this.setState({ uploadProgress: 100 });
                  setTimeout(() => this.manejarResultadoSubidaArchivos(res.data), 400);
                }, error => {
                  if (error.response?.status === 401) {
                    logout();
                  } else {
                    clearInterval(this.processingTimer);
                    this.processingTimer = null;
                    this.manejarResultadoSubidaArchivos({ error: true, mensaje: "No se pudo cargar el archivo." });
                  }
                  return error;
                });
            } else {
              this.manejarResultadoSubidaArchivos(res.data);
            }
          })
          .catch((error) => {
            clearInterval(this.processingTimer);
            this.processingTimer = null;
            if (error.response?.status === 401) {
              logout();
            } else {
              this.manejarResultadoSubidaArchivos({ error: true, mensaje: "No se pudo cargar el archivo." });
            }
          });
      }
    } else {
      this.setState({ errors: errors, showErrors: true });
      mostrarErroresEnFormulario(errors);
    }
  };


  componentDidMount() {
    configurarLimpiezaAutomatica()
    axios
      .get(
        URL + "tipoDocumento/listar/" + idEmpresa(),
        getAuthorizationHeader()
      )
      .then((res) => {
        if (res.data.error == false) {
          this.setState({ tipoDocumento: res.data.datos });
        }
      }, error => {
        if (error.response.status === 401) {
          logout();
        }
        return error;
      });
    axios
      .get(
        URL + "numeroPatronal/listar/" + idEmpresa(),
        getAuthorizationHeader()
      )
      .then((res) => {
        if (res.data.error == false) {
          this.setState({ numeroPatronal: res.data.datos });
        }
      }, error => {
        if (error.response.status === 401) {
          logout();
        }
        return error;
      });

  }

  validarExtensionDocumento = () => {
    let datos = this.state.tipoDocumento;
    let extension = datos.find(tipo => tipo.id == this.state.tipoDocumentoID)
    if (extension) {
      return extension.formato == "XML";
    }
    return false
  }

  handleInput = (e) => {
    let name = e.target.name;
    let val = e.target.value;
    this.setState(prevState => ({
      errors: {
        ...prevState.errors,
        [name]: null
      },
      [name]: val,
    }))
  };

  handleChangeSelect = (e) => {
    let name = e.target.name;
    let val = e.target.value;
    let documento = this.state.tipoDocumento.find(element => element.id == val);
    if (documento)
      this.setState({
        [name]: val,
        isCarpetaPorDefecto: documento.carpetaPorDefecto != "",
        carpetaPorDefecto: documento.carpetaPorDefecto,
        uploadDisabled: documento.carpetaPorDefecto != ""
      })
  }


  renderFormulario = () => {

    return (
      <div className="wrapperContent" >
        <div className="component-form">
          <div className="page-container">
            <div className="component-content card">
              <form onSubmit={this.subirArchivo} className="form container-sm">
                <h4 className="section__subtitle center-text">
                  Cargar lote de documentos
                </h4>
                <p className="section__description center-text">
                  Selecciona el archivo de lote comprimido en formato zip
                </p>

                  <div className="carga-documento-section" name="archivoLote">
                    <div className="carga-documento-content">
                      <DropzoneComponent
                        onFileSelected={this.handleArchivo}
                        archivos_soportados={["zip"]}
                      />
                    </div>
                  </div>

                {this.state.nombreArchivo && (
                  <div className="component-progress-upload">
                    <div className="contentInner">
                      <div className="icon-shape shape-xl">
                        <span className="material-symbols-outlined">folder_zip</span>
                      </div>
                      <div className="progress-content">
                        <div className="load-info">
                          <span className="file-name">{this.state.nombreArchivo}</span>
                        </div>
                        <div className="file-info">
                          <span className="file-size">{this.state.pesoArchivoMb}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="form-group__inline">
                  <div className="form-group">
                    <input
                      type="text"
                      name="descripcion"
                      placeholder=""
                      onChange={this.handleInput}
                      className="form-input"
                      value={this.state.descripcion}
                    />
                    <label className="form-label">Descripción</label>
                  </div>
                  <div className="form-group">
                    <select
                      className="form-select"
                      name="tipoDocumentoID"
                      id="tipoDocumentoID"
                      placeholder=""
                      onChange={this.handleChangeSelect}
                      value={this.state.tipoDocumentoID}
                    >
                      <option value=""> </option>
                      {this.state.tipoDocumento.map((elemento) => (
                        <option key={elemento.id} value={elemento.id}>
                          {elemento.nombre}
                        </option>
                      ))}
                    </select>
                    <label htmlFor="tipoDocumentoID" className="form-label">Tipo de documento</label>
                  </div>
                </div>
                {
                  this.validarExtensionDocumento() &&

                  <div className="form-group">
                    <select
                      className="form-select"
                      id="numeroPatronalID"
                      name="numeroPatronalID"
                      placeholder=""
                      onChange={this.handleInput}
                      value={this.state.numeroPatronalID}
                    >
                      <option value=""> </option>
                      {this.state.numeroPatronal.map((elemento) => (
                        <option value={elemento.id} key={elemento.id}>{elemento.nombre}</option>
                      ))}
                    </select>
                    <label htmlFor="numeroPatronalID" className="form-label"> Nro. MTESS patronal</label>
                  </div>
                }

                {
                  this.state.isCarpetaPorDefecto &&
                  <div className="form-group">
                    <input
                      type="text"
                      name="carpetaPorDefecto"
                      id="carpetaPorDefecto"
                      placeholder=""
                      onChange={this.handleInput}
                      className="form-input"
                      value={this.state.carpetaPorDefecto}
                    />
                    <label htmlFor="carpetaPorDefecto" className="form-label">Carpeta por defecto</label>
                  </div>
                }

                <div className="form-actions">
                  <button
                    onClick={() => this.props.history.push('/lotes/generar')}
                    className="btn-medium btn-link"
                  >
                    Cancelar
                  </button>

                  <button
                    type="submit"
                    className="btn-medium btn-primary"
                  >
                    Continuar
                  </button>

                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {

    const breadcrumb = [
      { label: 'Nuevo Lote', path: '/lotes/generar' },
      { label: 'Importar Lote desde Zip', path: '' },
    ];

    return (
      <div className="template-base">
        <header className="component-header">
          <div className="page-container">
            <BreadCrumComponent
              backUrl="/lotes/generar"
              breadcrumbs={breadcrumb}
            />
            <div className="head-area">
              <div className="caption-area">
                <h1 className="page-title">
                  Importar Lote desde Zip
                </h1>
                <p className="page-description">
                  Complete el siguiente formulario con los datos correspondientes
                </p>
              </div>
            </div>
          </div>
        </header>
        { this.renderFormulario() }
        <PantallaCarga
          open={this.state.openPantallaCarga}
          mensaje={this.state.uploadProgress !== null && this.state.uploadProgress <= 50
            ? "Subiendo archivo..."
            : "Procesando lote..."}
          progress={this.state.uploadProgress}
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  exportarArchivo: (file) => dispatch(exportarArchivo(file))
});

export default connect(null, mapDispatchToProps)(ImportarLote);
